import { useMemo } from 'react';

import SubActivityPrint from '../../sub-activity/sub-activity-print';
import {
  RESPONSE_FREE,
  ViewProps,
} from './interactive-response-categorise.constants';
import { initialise } from './play/interactive-response-categorise-play.utils';
import {
  InteractiveResponseTitle,
  InteractiveResponseViewScaler,
} from '../shared/interactive-response-shared';
import { InteractiveResponseContainer } from '../interactive-response.style';
import InteractiveDragDisplay from '../../shared/interactive-drag-drop/interactive-drag-display';
import * as Styled from './interactive-response-categorise-print.style';
import { ComponentAspectRatio } from '../../shared/component-height/component-dimensions';
import { ComponentAbsoluteWrapper } from '../../shared/component-height/component-dimensions.style';
import { useContainerDimensions } from '../../shared/component-height/component-dimensions.hooks';
import { defaultDimensions } from '../interactive-response-shared.constants';
import { CommonPrintProps } from 'approot/activity-builder/activity-builder.constants';

const InteractiveResponseCategorisePrint = ({
  properties,
  subActivityProperties,
}: ViewProps & CommonPrintProps) => {
  const { dragItems, dropItems } = useMemo(() => {
    return initialise({
      items: properties.interactiveResponseCategorise.items,
      categories: properties.interactiveResponseCategorise.categories,
      showAnswer:
        properties.interactiveResponseCategorise.answerType !== RESPONSE_FREE,
      isShowNumberOfItemsHint:
        !!properties.interactiveResponseCategorise.showNumberOfItemsHint,
      shouldShuffle: true,
      variant: properties.interactiveResponseCategorise.variant,
    });
  }, [
    properties.interactiveResponseCategorise.items,
    properties.interactiveResponseCategorise.categories,
    properties.interactiveResponseCategorise.answerType,
    properties.interactiveResponseCategorise.showNumberOfItemsHint,
    properties.interactiveResponseCategorise.variant,
  ]);

  const { setContainerElement } = useContainerDimensions({
    aspectRatio: 16 / 9,
  });

  return (
    <SubActivityPrint subActivityDetails={subActivityProperties}>
      <InteractiveResponseContainer>
        <ComponentAspectRatio
          dimensions={properties.categoriseDimensionData || defaultDimensions}
        >
          <ComponentAbsoluteWrapper ref={setContainerElement}>
            <InteractiveResponseViewScaler>
              <InteractiveResponseTitle
                title={properties.interactiveResponseCategorise.title}
                subTitle={properties.interactiveResponseCategorise.subTitle}
              />

              <Styled.InteractiveResponsePrintDragZone>
                {dragItems.map((dragItem, index) => (
                  <Styled.InteractiveResponsePrintDragZoneItem
                    key={`${dragItem.id}-${index}`}
                  >
                    <InteractiveDragDisplay
                      imageUrl={dragItem.question.image?.small}
                      isFit={dragItem.question.image?.isFit}
                      description={dragItem.question.image?.description || ''}
                      baseColour={dragItem.question.baseColour}
                      variant={dragItem.question.variant}
                      text={dragItem.question.text}
                      richtext={dragItem.question.richtext}
                    />
                  </Styled.InteractiveResponsePrintDragZoneItem>
                ))}
              </Styled.InteractiveResponsePrintDragZone>

              <Styled.InteractiveResponsePrintCategories>
                {dropItems.map(dropItem => {
                  return (
                    <Styled.InteractiveResponsePrintCategory key={dropItem.id}>
                      <Styled.InteractiveResponsePrintCategoryLabel>
                        {dropItem.label}
                      </Styled.InteractiveResponsePrintCategoryLabel>
                      <Styled.InteractiveResponsePrintCategoriseDropTarget></Styled.InteractiveResponsePrintCategoriseDropTarget>
                    </Styled.InteractiveResponsePrintCategory>
                  );
                })}
              </Styled.InteractiveResponsePrintCategories>
            </InteractiveResponseViewScaler>
          </ComponentAbsoluteWrapper>
        </ComponentAspectRatio>
      </InteractiveResponseContainer>
    </SubActivityPrint>
  );
};

export default InteractiveResponseCategorisePrint;
